import { appData } from '@/mocks/home-data';

export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/70">
          <div className="flex-shrink-0">
            <div className="w-36 h-36 md:w-44 md:h-44 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20mobile%20app%20icon%20design%20with%20a%20stylized%20chat%20bubble%20and%20news%20elements%20in%20warm%20coral%20and%20amber%20tones%2C%20clean%20flat%20design%2C%20sophisticated%20editorial%20aesthetic%2C%20on%20subtle%20warm%20gradient%20background&width=400&height=400&seq=app-icon-main&orientation=squarish"
                alt="吃瓜每日大赛 APP 图标"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-2">{appData.title}</h2>
            <p className="text-sm font-medium text-primary-600 mb-4">{appData.subtitle}</p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              {appData.description}
            </p>
            <div className="grid grid-cols-2 gap-3 mb-6 max-w-sm mx-auto lg:mx-0">
              {appData.features.map((f, i) => (
                <div key={i} className="flex items-center gap-2 text-xs text-foreground-700">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100">
                    <i className="ri-check-line text-primary-600 text-xs"></i>
                  </span>
                  {f}
                </div>
              ))}
            </div>
            <div className="flex items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-white rounded-md text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-apple-line text-lg"></i>
                App Store
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-white rounded-md text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-google-play-line text-lg"></i>
                Google Play
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}